import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61ff7b3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-bg" }, null, -1))
const _hoisted_2 = { class: "second-filter" }
const _hoisted_3 = { class: "list-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "年级", -1))
const _hoisted_5 = { class: "grade-content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "list-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "学期", -1))
const _hoisted_9 = { class: "grade-content" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "list-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "难度", -1))
const _hoisted_13 = { class: "grade-content" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "list-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "名校", -1))
const _hoisted_17 = { class: "grade-content" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "list-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "类型", -1))
const _hoisted_21 = { class: "grade-content" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "list-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "年份", -1))
const _hoisted_25 = { class: "grade-content year" }
const _hoisted_26 = { class: "list" }
const _hoisted_27 = { class: "year-list" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "更早", -1))
const _hoisted_30 = { class: "year-list-more" }
const _hoisted_31 = ["onClick"]

import { computed, ref, watch } from "vue";
import AreaSelectComp from "@/components/paper/areaSelect-component.vue";
import { FiltersName } from "@/const/paper";


export default /*#__PURE__*/_defineComponent({
  __name: 'filter-component',
  props: {
  dictionary: {
    type: Object,
    default: () => {
      return {};
    },
  },
  gradeList: {
    type: Array,
    default: () => {
      return [];
    },
  },
  selectedSubject: {
    type: Object,
    default: () => {
      return {};
    },
  },
  gradeClassifyDefault: {
    type: Object,
    default: () => {
      return {};
    },
  },
},
  emits: ["paramsChangeListenter"],
  setup(__props, { emit: $emit }) {

const props = __props;



const showMoreYear = ref(false);
const classifyDataList = ref([]);
const gradeValue = ref(-1); // 年级筛选值
const semesterValue = ref("-1"); // 学期筛选值
const difficultyValue = ref("-1"); // 难度筛选值
const schoolTypeValue = ref("-1"); // 名校筛选值
const classifyValue = ref("-1"); // 类型筛选值
const yearValue = ref("-1"); // 年份筛选值
const areaValue = ref({
  value: -1,
  text: "全国",
  parentId: -1,
  order: 0,
}); // 地区筛选值

const divisionMap = {
  1: "classifyPrimary",
  2: "classifyJunior",
  3: "classifySenior",
};


const gradeListData = computed(() => {
  return [
    {
      division_id: 1,
      division_name: "小学",
      id: -1,
      name: "全部",
      sort_flag: 0,
    },
    ...props.gradeList,
  ];
});
const dictionaryData = computed(() => {
  return props.dictionary;
});

const handleParamsChange = (type) => {
  let params = {
    grade: gradeValue.value,
    semester: semesterValue.value,
    school_type: schoolTypeValue.value,
    year: [yearValue.value],
    classify: classifyValue.value,
    difficulty: difficultyValue.value,
    province: areaValue.value?.value + "",
  };

  // 去掉key = -1的参数
  for (let key in params) {
    if (key === "year" && params[key][0] === "-1") {
      delete params[key];
    }
    if (params[key] === "-1" || params[key] === -1) {
      delete params[key];
    }
  }
  const paramsName = []
  Object.keys(params).map(key => {
    const screen = FiltersName[key]
    let content
    switch (key) {
      case 'province':
        content = areaValue.value?.text
        break;
      case 'grade':
        content = gradeListData.value.find(item => item.id === params[key])?.name
        break;
      case 'semester':
        content = dictionaryData.value.semester.find(item => item.value === params[key])?.text
        break;
      case 'difficulty':
        content = dictionaryData.value.difficulty.find(item => item.value === params[key])?.text
        break;
      case 'school_type':
        content = dictionaryData.value.schoolType.find(item => item.value === params[key])?.text
        break;
      case 'classify':
        content = classifyDataList.value.find(item => item.value === params[key])?.text
        break;
      case 'year':
        content = params[key].map(item => dictionaryData.value.year.find(year => year.value === item)?.text).join(',')
        break;
      default:
        content = '全部'
        break;
    }
    paramsName.push({
      screen,
      content
    })
  })
  $emit("paramsChangeListenter", params, type, paramsName);
};

// 选择更早年份
const selectMoreYear = () => {
  showMoreYear.value = !showMoreYear.value;
};

// 地区筛选
const changeArea = (currentArea) => {
  areaValue.value = currentArea;
  handleParamsChange('select');
};
// 年级筛选
const handleSelectGrade = (grade) => {
  gradeValue.value = grade.id;
  handleParamsChange('select');
};
// 学期筛选
const handleSelectSemester = (semester) => {
  semesterValue.value = semester.value;
  handleParamsChange('select');
};
// 难度筛选
const handleSelectDifficulty = (difficulty) => {
  difficultyValue.value = difficulty.value;
  handleParamsChange('select');
};
// 名校筛选
const handleSelectSchoolType = (schoolType) => {
  schoolTypeValue.value = schoolType.value;
  handleParamsChange('select');
};
// 试卷类型筛选
const handleSelectClassify = (classifyVal) => {
  classifyValue.value = classifyVal;
  handleParamsChange('select');
};
// 年份筛选
const handleSelectYear = (year) => {
  yearValue.value = year.value;
  handleParamsChange('select');
};

// 学科改变
watch(
  () => props.selectedSubject,
  (newVal) => {
    // 学科和学部改变
    classifyValue.value = -1;
    gradeValue.value = -1;
    if (newVal) {
     setTimeout(() => {
      const divisionList = props.dictionary?.classify[divisionMap[props.selectedSubject.divisionId]];
      if (divisionList) {
        classifyDataList.value = divisionList[`subject${props.selectedSubject.value}`];
        handleParamsChange(newVal.type);
      }
     }, 10);
    }
  }
);
// 学科年级默认值
watch(
  () => props.gradeClassifyDefault,
  (newVal) => {
    if (newVal) {
      // 学科和学部改变时 年级和试卷类型变化
      setTimeout(() => {
        gradeValue.value = newVal.grade || -1;
        classifyValue.value = newVal.classify || '-1'
      }, 10);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter", showMoreYear.value ? 'filter-expand-height' : 'filter-normal-height'])
  }, [
    _hoisted_1,
    _createVNode(AreaSelectComp, { onChangeArea: changeArea }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("section", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gradeListData.value, (grade) => {
            return (_openBlock(), _createElementBlock("span", {
              key: grade.id,
              onClick: ($event: any) => (handleSelectGrade(grade)),
              class: _normalizeClass(grade.id == gradeValue.value ? 'active' : '')
            }, _toDisplayString(grade?.name), 11, _hoisted_6))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("section", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryData.value?.semester, (semester) => {
            return (_openBlock(), _createElementBlock("span", {
              onClick: ($event: any) => (handleSelectSemester(semester)),
              class: _normalizeClass(semester.value == semesterValue.value ? 'active' : ''),
              key: semester.id + 1
            }, _toDisplayString(semester?.text), 11, _hoisted_10))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("section", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryData.value?.difficulty, (difficulty) => {
            return (_openBlock(), _createElementBlock("span", {
              onClick: ($event: any) => (handleSelectDifficulty(difficulty)),
              class: _normalizeClass(difficulty.value == difficultyValue.value ? 'active' : ''),
              key: difficulty.id + 1
            }, _toDisplayString(difficulty?.text), 11, _hoisted_14))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("section", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryData.value?.schoolType, (schoolType) => {
            return (_openBlock(), _createElementBlock("span", {
              onClick: ($event: any) => (handleSelectSchoolType(schoolType)),
              class: _normalizeClass(schoolType.value == schoolTypeValue.value ? 'active' : ''),
              key: schoolType.id + 1
            }, _toDisplayString(schoolType?.text), 11, _hoisted_18))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("section", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classifyDataList.value, (classify) => {
            return (_openBlock(), _createElementBlock("span", {
              onClick: ($event: any) => (handleSelectClassify(classify.value)),
              class: _normalizeClass(classify.value == classifyValue.value ? 'active' : ''),
              key: classify.id + 1
            }, _toDisplayString(classify?.text), 11, _hoisted_22))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("section", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryData.value?.year?.slice(0, 16), (year) => {
                return (_openBlock(), _createElementBlock("span", {
                  onClick: ($event: any) => (handleSelectYear(year)),
                  class: _normalizeClass(year.value == yearValue.value ? 'active' : ''),
                  key: year.id + 1
                }, _toDisplayString(year?.text), 11, _hoisted_28))
              }), 128)),
              _createElementVNode("div", {
                class: "more",
                onClick: selectMoreYear
              }, [
                _hoisted_29,
                _createElementVNode("i", {
                  class: _normalizeClass(showMoreYear.value ? 'up' : 'down')
                }, null, 2)
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryData.value?.year?.slice(
                  16,
                  dictionaryData.value?.year?.length
                ), (year) => {
                return (_openBlock(), _createElementBlock("span", {
                  onClick: ($event: any) => (handleSelectYear(year)),
                  class: _normalizeClass(year.value == yearValue.value ? 'active' : ''),
                  key: year.id + 1
                }, _toDisplayString(year?.text), 11, _hoisted_31))
              }), 128))
            ], 512), [
              [_vShow, showMoreYear.value]
            ])
          ])
        ])
      ])
    ])
  ], 2))
}
}

})